import React from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router';
import Footer from '../Footer';
import CustomBtn from '../../../generic/CustomBtn';
import logo from '../../../assets/image/logo.svg';

const LayoutSimple = ({ children }) => {
  const translate = useIntl();
  const history = useHistory();

  return (
    <div className="layout__simple">
      <div className="logo">
        <img src={logo} alt="logo" />
      </div>
      <div className="page">
        {children}
      </div>
      <CustomBtn
        label={translate.formatMessage({ id: 'button-cancel' })}
        customClass="btn__cancel back"
        iconClass="icon-close"
        handleClick={() => {
          history.push('/');
        }}
      />
      <Footer />
    </div>
  );
};

export default LayoutSimple;
